<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>Refund Policy</h2>
            <ul>
                <li>
                    <a routerLink="/">
                        Home
                    </a>                
                </li>
                <li>
                    Refund Policy
                </li>
            </ul>
        </div>
    </div>
</div>


<section class="features-area ptb-110">
    <div class="container">
        <div class="overview-box">
            <div class="row" style="text-align: justify;">
                <h1>
                    Refund policy
                </h1>
               
                
                <p class="mt-2">
                    Since the Website offers non-tangible, irrevocable goods we do not provide refunds after the product is purchased, which you acknowledge prior to purchasing any product on the Website. Please make sure that you've carefully read service description before making a purchase.
                </p>
               
                <h1 class="mt-3 mb-3">
                    Contacting us

                </h1>
                <div style="line-height: 30px;">
                <p>
                    If you have any questions, concerns, or complaints regarding this refund policy, we encourage you to contact us using the details below:
                </p>
               

                 
                    <p>
                        <strong>Email-id:</strong>
                        <a href="mailto: SUPPORT@VOCBOT.AI" style="display: contents !important;color: blue;">
                            SUPPORT@VOCBOT.AI
                        </a>
                    </p>
                    <p>
                        <strong>Phone Number:</strong>
                        <a href="tel:+91-9826323332" style="display: contents !important;">
                            +91-9826323332
                        </a> 
                    </p>
                    <p>
                        <strong>Address:</strong>
                        43 Pratap Nagar, &nbsp;Manik Bagh Road, &nbsp;Near Gurunanak Dharmashala &nbsp;Indore (M.P.), &nbsp;452001
                    </p>

                    <h3 class="mt-2" style="float: right;">
                        <strong>
                            Last updated:
                        </strong>
                            &nbsp;March 27, 2024
                    </h3>
                        </div>                
            </div>
        </div>
    </div>
</section>